import { CustomerRole } from '@edgebox/data-definitions';
import React, { useContext } from 'react';
import { Nav } from '@edgebox/react-components';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { ApiContext } from '../../../common';
import { AppContext } from '../../../common/contexts/AppContext';
import { FullWidthTabsPageLayout } from '../../Layouts/FullWidthTabsPageLayout';

export function AccountTabsLayout() {
  const api = useContext(ApiContext);
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();

  const customerRoles = api?.currentUser?.customerRoles;
  const canManageUsers = customerRoles?.includes(CustomerRole.Owner);
  const canViewInvoices = customerRoles?.includes(CustomerRole.Owner) || customerRoles?.includes(CustomerRole.ManageFinances);
  const hasCustomer = !!appContext.customer;

  const activeTab = location.pathname.startsWith('/subscriptions')
    ? '/subscriptions'
    : location.pathname.startsWith('/account/users')
      ? '/account/users'
      : location.pathname.startsWith('/account/billing')
        ? '/account/billing'
        : '/account/profile';

  return (
    <FullWidthTabsPageLayout
      size="large"
      tabs={
        <Nav
          variant="tabs"
          id="account-tabs"
          className={'m-0 ps-2 pe-2 pt-0 pb-0'}
          activeKey={activeTab}
          onSelect={(key) => {
            if (!key) {
              return;
            }
            navigate(`${key}${location.search}`);
          }}
        >
          <Nav.Item>
            <Nav.Link eventKey="/account/profile">My account</Nav.Link>
          </Nav.Item>
          {hasCustomer && canViewInvoices ? (
            <Nav.Item>
              <Nav.Link eventKey="/subscriptions">Subscriptions</Nav.Link>
            </Nav.Item>
          ) : null}
          {canManageUsers ? (
            <Nav.Item>
              <Nav.Link eventKey="/account/users">Users</Nav.Link>
            </Nav.Item>
          ) : null}
          {hasCustomer && canViewInvoices ? (
            <Nav.Item>
              <Nav.Link eventKey="/account/billing">Billing</Nav.Link>
            </Nav.Item>
          ) : null}
        </Nav>
      }
    >
      <Outlet />
    </FullWidthTabsPageLayout>
  );
}
